import { render, staticRenderFns } from "./OnlyOnBigBoxCard.vue?vue&type=template&id=464c24be&scoped=true&"
import script from "./OnlyOnBigBoxCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./OnlyOnBigBoxCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OnlyOnBigBoxCard.vue?vue&type=style&index=0&id=464c24be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464c24be",
  null
  
)

export default component.exports